import { useMutation, useQueryClient } from "react-query";
import authAPI from "../authAPI";

export const useToggleHiddenFeideGroup = () => {
  const queryClient = useQueryClient();

  return useMutation(
    ({ feideGroupId, organizationId }) =>
      authAPI.toggleHiddenFeideGroup(feideGroupId, organizationId),
    {
      onSuccess: (data, variables) => {
        queryClient.invalidateQueries(["feideGroups", variables.organizationId]);
        queryClient.invalidateQueries(["group"]);
        queryClient.invalidateQueries(["organizations"]);
      },
      onError: (error) => {
        console.error("Error while toggling hidden FEIDE group:", error);
      },
    }
  );
};
